import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_67: FaireProductEntity = {
  token: "catalog_prod_prod-67",
  type: "product",
  name: "Ascent Deco Sculpture - Style 3",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=400&fit=crop",
  priceDollars: 99.26,
  msrpDollars: 248.15,
  sku: "JA0067",
  caseSize: 1,
  material: "Ceramic",
  collectionToken: "col_japandi",
  categoryTokens: ["catalog_cat_dogs"],
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 292,
  description: "Beautiful Japandi piece perfect for any home.",
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
